// ** Custom Icon Import
import Icon from 'src/@core/components/icon'

const UserIcon = ({ icon, ...rest }) => {
  return <Icon icon={icon} {...rest} />
}

export default UserIcon
